<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="线下支付" left-arrow fixed @click-left="back"/>
        <van-row>
            <van-col span="24">
                <div class="jump-order-body">
                    <div class="jump-order-body-whd">
                        <i class="iconfont icon-hezuowoshou"></i>
                    </div>
                    <div class="jump-order-body-foot">
                        <!--<p>银行流水号：<span>{{orderId}}</span></p>
                        <p>转账金额：<span>{{orderPrice}}元</span></p>-->
                    </div>
                    <div class="jump-order-body-foot-hd">
                        <van-field label="银行流水号" v-model="bankDealNum"/>
                        <van-field label="转账金额" type="number" v-model="price"/>
                        <van-uploader :after-read="onRead">
                            <van-field label="支付凭证" v-model="accessoryText" readonly placeholder="请选择凭证"/>
                        </van-uploader>
                        <img style="width: 100%; height: auto;" v-if="imgUrl!=''" :src="imgUrl" ref="idImg"/>
                        <van-field type="textarea" label="备注信息" v-model="remarks"/>
                        <van-button size="large" @click="pay">确定支付</van-button>
                    </div>
                </div>
            </van-col>
            <van-col span="4"></van-col>
        </van-row>
    </div>
</template>
<script>
    import {NavBar, Button, Row, Col, Field, Uploader} from "vant";

    export default {
        name: "orderpayoffline",
        components: {
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Field.name]: Field,
            [Uploader.name]: Uploader
        },
        data() {
            return {
                orderIds: '',
                orderId: 0,//显示
                orderPrice: 0,
                bankDealNum: '',
                remarks: '',
                accessoryId: '',
                accessoryText: '',
                uploadCertificateUrl: '',
                id: '',
                orders: '',
                price: 0,
                imgUrl:''
            };
        },
        methods: {
            back() {
                history.back();
            },
            onRead(file, detail) {
                let that = this;
                let fileFormData = new FormData();
                fileFormData.append('files', file.file)
                that.$api.post(that.uploadCertificateUrl, fileFormData, successRes => {
                    if (successRes.result) {
                        that.accessoryId = successRes.data.id;
                        that.imgUrl = successRes.data.imgUrl;
                        that.$toast('上传成功!');
                    } else {
                        that.$toast('上传失败!');
                    }
                })
            },
            pay() {
                let that = this;
                that.$api.post(that.jumuc.userCenter.milkPayunderLinePay,
                    {
                        milkConfirmId:that.id,
                        bankWater:that.bankDealNum,
                        bankWaterMoney:that.price,
                        accessoryId:that.accessoryId,
                        remark:that.remarks
                    },
                    successResPay => {
                        that.$toast(successResPay.msg);
                        if (successResPay.success) {
                            location.href = "#/user/bill"
                        }
                    })
            },getMaxMoneyPay(){
                let that = this;
                that.$api.get(that.jumuc.userCenter.getMaxMoneyPay,
                    {"milkConfirmId":that.id},
                    successResPay => {
                        that.uploadCertificateUrl=successResPay.data.uploadCertificateUrl
                    })
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getMaxMoneyPay()
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
.van-uploader{
  width: 100%;
}
    .jump-order {
        padding-top: 50px;

        &-body {
            padding-top: 40px;
            &-whd {
                text-align: center;
                i {
                    color: #1989fa;
                    font-size: 60px;
                }
                p {
                    padding: 20px 0;
                }
            }
            &-foot {
                padding: 0 60px;
                p {
                    padding-left: 15px;
                    margin-bottom: 10px;
                    span {
                        color: red;
                    }
                }
            }
            &-foot-hd {
                padding: 0 20px;
                button {
                    background-color: @bule-thame;
                    color: white;
                    font-weight: 700;
                    border-radius: 50px;
                    margin: 25px 0 10px;
                }
                .van-field__label {
                    color: @bule-thame;
                }
            }
        }
    }
</style>


